import { render } from "./preDeposit.vue?vue&type=template&id=d68f267e&scoped=true"
import script from "./preDeposit.vue?vue&type=script&lang=js"
export * from "./preDeposit.vue?vue&type=script&lang=js"

import "./preDeposit.vue?vue&type=style&index=0&id=d68f267e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d68f267e"

export default script